import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import ErrorRows from './Rows/ErrorRows';
import WarningRows from './Rows/WarningRows';
import AcknowledgeButton from './Rows/AcknowledgeButton';
import styles from './NewEventsTable.less';

import {routes} from '../../constants/';

export class NewEventsTable extends PureComponent {
    static propTypes = {
        canDismissEvents: PropTypes.bool,
        totalStats: PropTypes.number,
    };

    static defaultProps = {
        canDismissEvents: false,
        totalStats: 0,
    };

    static contextTypes = {
        i18n: PropTypes.func,
    };

    render() {
        const {canDismissEvents, totalStats} = this.props;

        if (totalStats === 0) {
            return null;
        }

        const errorTextI18nAlias = canDismissEvents ? 'johnson.page.headline.description.warning' : 'johnson.page.headline.description.error';
        const errorText = this.context.i18n(errorTextI18nAlias, `<a href="${routes.kbLinkStartStopConfluence}" target="_blank">`, '</a>');

        return (
            <div>
                <div className={styles.eventsHeadline} dangerouslySetInnerHTML={{__html: errorText}} />
                <ErrorRows />
                <WarningRows />
                <AcknowledgeButton />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    canDismissEvents: state.events.canDismissEvents,
    totalStats: state.events.stats.total,
});

export default connect(mapStateToProps)(NewEventsTable);



// WEBPACK FOOTER //
// ./src/components/NewEventsTable/NewEventsTable.js